import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 're-configuration-delete-confirmation-dialog',
  templateUrl: './uses-matrixcare-confirmation-dialog.component.html',
  styleUrls: ['./uses-matrixcare-confirmation-dialog.component.scss'],
  standalone: true
})
export class UsesMatrixcareConfirmationDialogComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void {
  }


  accept() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
